var _ellipse, _path, _ellipse2, _path2, _ellipse3, _path3, _ellipse4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSqlDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    height: "24px",
    role: "img",
    "aria-label": "SQL database",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 64,
    cy: 28,
    rx: 34,
    ry: 12,
    fill: "#60A5FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 28v20c0 6.63 15.2 12 34 12s34-5.37 34-12V28",
    fill: "#3B82F6"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 64,
    cy: 48,
    rx: 34,
    ry: 12,
    fill: "#60A5FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30 48v20c0 6.63 15.2 12 34 12s34-5.37 34-12V48",
    fill: "#2563EB"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 64,
    cy: 68,
    rx: 34,
    ry: 12,
    fill: "#60A5FA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30 68v20c0 6.63 15.2 12 34 12s34-5.37 34-12V68",
    fill: "#1D4ED8"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 64,
    cy: 88,
    rx: 34,
    ry: 12,
    fill: "#93C5FD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSqlDefault);
export default __webpack_public_path__ + "static/media/SQLDefault.1e2562b5747a5dc6627a43fcefe93d83.svg";
export { ForwardRef as ReactComponent };